module.exports = __webpack_public_path__ + "img/application-rejected.fd36338c.svg";